import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AppService } from '../../shared/app.service';

@Component({
  selector: 'app-whatsapp-fab',
  standalone: true,
  imports: [CommonModule],
  template: `
    <a *ngIf="appService.isMobileDevice && appService.whatsappPhoneNumber()"
       [href]="'https://wa.me/' + appService.whatsappPhoneNumber()"
       target="_blank"
       rel="noopener noreferrer"
       class="whatsapp-fab"
       aria-label="Contactar por WhatsApp">
      <img src="/assets/icon/whatsapp-float.svg" alt="WhatsApp" width="60" height="60" />
    </a>
  `,
  // if Tawk.to is removed, take back to 'right: 20px;'
  // if Tawk.to is present, keep 'right: 27px;'
  styles: [`
    .whatsapp-fab {
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 2000;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
      transition: transform 0.2s ease;
      cursor: pointer;
    }

    .whatsapp-fab:hover {
      transform: scale(1.08);
    }

    .whatsapp-fab img {
      display: block;
    }
  `]
})
export class WhatsappFabComponent {
  constructor(public appService: AppService) { }
}
